import { DatePipe, Location, formatDate } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FileService } from '../file.service';
import { DialogType, MediDialogComponent } from '../medi-dialog/medi-dialog.component';
import { OroService } from '../oroservice';

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.scss'],
    standalone: false
})

export class OrderDetailComponent implements OnInit {
    id: number;
    private sub: any;
    isEditing: boolean;

    auftrag: any = {};

    ctrForderungsart = new FormControl();
    ctrReferenz = new FormControl();
    ctrRechnungsdatum = new FormControl();
    ctrBetrag = new FormControl();
    ctrPersonenart = new FormControl();
    ctrAnrede = new FormControl();
    ctrBriefanrede = new FormControl();
    ctrVorname = new FormControl();
    ctrName = new FormControl();
    ctrAnschrift = new FormControl();
    ctrAdresszusatz = new FormControl();
    ctrHausnummer = new FormControl();
    ctrPostfach = new FormControl();
    ctrLand = new FormControl();
    ctrPLZ = new FormControl();
    ctrOrt = new FormControl();

    ctrAnredePat = new FormControl();
    ctrVornamePat = new FormControl();
    ctrNamePat = new FormControl();
    ctrBeziehungPat = new FormControl();
    ctrAnschriftPat = new FormControl();
    ctrAdresszusatzPat = new FormControl();
    ctrHausnummerPat = new FormControl();
    ctrPostfachPat = new FormControl();
    ctrLandPat = new FormControl();
    ctrPLZPat = new FormControl();
    ctrOrtPat = new FormControl();

    hasBehandlungsdatumError: boolean = false;
    hasRechnungsdatumError: boolean = false;
    hasBehandlungsdatumInvalidError: boolean = false;
    hasBehandlungsdatumFutureError: boolean = false;
    hasRechnungsdatumBehandlungsdatumError: boolean = false;
    hasRechnungsdatumInvalidError: boolean = false;
    hasTeilzahlungsError: boolean = false;
    hasGeburtsdatumError: boolean = false;
    hasGeburtsdatumInvalidError: boolean = false;
    hasGeburtsdatumPatError: boolean = false;
    hasGeburtsdatumPatInvalidError: boolean = false;
    hasMindestbetragError: boolean = false;

    behandlungsdatumText: string = '';
    rechnungsdatumText: string = '';
    geburtsdatumText: string = '';
    geburtsdatumPatText: string = '';

    OldData: string;

    plzinfolisteFull = [];
    plzinfolisteFilter = [];
    plzinfolisteFilterPat = [];

    readonly briefanredeDe = "Sehr geehrte Damen und Herren";

    constructor(
        public oroservice: OroService,
        public fileservice: FileService,
        private route: ActivatedRoute,
        private _location: Location,
        public dialog: MatDialog,
        private _router: Router) {
    }

    ngOnInit(): void {
        this.oroservice.getKundenInfo().then(
            () => {
                this.initForm();
            }
        );

        try {
            this.oroservice.getPlz().subscribe((data: []) => {
                this.plzinfolisteFull = data;
                this.plzinfolisteFilter = [...data];
                this.plzinfolisteFilterPat = [...data];
                this.checkPlz();
                this.checkPlzPat();
            });
        } catch (ex) {
            console.log("Error: " + ex);
        }
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        this.convertDates()
        const NewData = JSON.stringify(this.auftrag).replace(/null/g, "\"\"");

        return (this.fileservice.files.length === 0 && this.OldData.localeCompare(NewData)===0);
	}

    /**
     * Convert dates in yyyy-MM-dd format
     */
    private convertDates(): void {
        if (this.auftrag.Rechnungsdatum) {
            this.auftrag.Rechnungsdatum = this.toIsoDate(this.auftrag.Rechnungsdatum);
        }

        if (this.auftrag.Behandlungsdatum) {
            this.auftrag.Behandlungsdatum = this.toIsoDate(this.auftrag.Behandlungsdatum);
        }

        if (this.auftrag.Zinsdatum) {
            this.auftrag.Zinsdatum = this.toIsoDate(this.auftrag.Zinsdatum);
        }

        if (this.auftrag.Datum) {
            this.auftrag.Datum = this.toIsoDate(this.auftrag.Datum);
        }

        if (this.auftrag.Geburtsdatum) {
            this.auftrag.Geburtsdatum = this.toIsoDate(this.auftrag.Geburtsdatum);
        }

        if (this.auftrag.GeburtsdatumPat) {
            this.auftrag.GeburtsdatumPat = this.toIsoDate(this.auftrag.GeburtsdatumPat);
        }
    }

    /**
     * Konvertiert ein Date-Objekt oder einen String zu 'YYYY-MM-DD'.
     */
    private toIsoDate(value: any): string {
        const date = this.parseStrictDate(value);
        if (!date) return '';
        return formatDate(date, 'yyyy-MM-dd', 'en-US');
    }

    /**
     * Konvertiert ein Datum zu Anzeigeformat 'dd.MM.yyyy'.
     */
    private toDisplayDate(value: any): string {
        const date = this.parseStrictDate(value);
        if (!date) return '';
        return formatDate(date, 'dd.MM.yyyy', 'en-US');
    }

    private parseStrictDate(value: any): Date | null {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return isNaN(value.getTime()) ? null : new Date(value.getTime());
        }

        if (typeof value !== 'string') {
            return null;
        }

        const trimmed = value.trim();
        if (!trimmed) {
            return null;
        }

        let match = /^([0-9]{2})\.([0-9]{2})\.([0-9]{4})$/.exec(trimmed);
        if (match) {
            const day = Number(match[1]);
            const month = Number(match[2]);
            const year = Number(match[3]);
            const parsed = new Date(year, month - 1, day);

            if (parsed.getFullYear() === year && parsed.getMonth() === month - 1 && parsed.getDate() === day) {
                return parsed;
            }

            return null;
        }

        match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(trimmed);
        if (match) {
            const year = Number(match[1]);
            const month = Number(match[2]);
            const day = Number(match[3]);
            const parsed = new Date(year, month - 1, day);

            if (parsed.getFullYear() === year && parsed.getMonth() === month - 1 && parsed.getDate() === day) {
                return parsed;
            }
        }

        return null;
    }

    initForm() {
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id'];

            if (this.id && this.id > 0) {
                this.isEditing = true;
                this.oroservice.getKundenInfo();
                this.oroservice.getAuftrag(this.id).then(
                    (object) => {
                        this.auftrag = object;
                        this.auftrag.Behandler = this.oroservice.getBehandlerObject(this.oroservice.isEmptyObject(this.auftrag.Behandler) ? 0 : this.auftrag.Behandler.Id);
                        this.auftrag.Rechnungsdatum = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.auftrag.Rechnungsdatum), 'yyyy-MM-dd');
                        this.auftrag.Behandlungsdatum  = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.auftrag.Behandlungsdatum ), 'yyyy-MM-dd');
                        this.auftrag.Zinsdatum = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.auftrag.Zinsdatum), 'yyyy-MM-dd');
                        this.auftrag.Datum = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.auftrag.Datum), 'yyyy-MM-dd');
                        this.auftrag.Geburtsdatum = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.auftrag.Geburtsdatum), 'yyyy-MM-dd');
                        this.auftrag.GeburtsdatumPat = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.auftrag.GeburtsdatumPat), 'yyyy-MM-dd');
                        this.auftrag.RemoveDokument = false;
                        this.OldData = JSON.stringify(this.auftrag).replace(/null/g,"\"\"");
                        this.auftrag.Briefanrede = this.briefanredeDe;
                        this.behandlungsdatumText = this.toDisplayDate(this.auftrag.Behandlungsdatum);
                        this.rechnungsdatumText = this.toDisplayDate(this.auftrag.Rechnungsdatum);
                        this.geburtsdatumText = this.toDisplayDate(this.auftrag.Geburtsdatum);
                        this.geburtsdatumPatText = this.toDisplayDate(this.auftrag.GeburtsdatumPat);
                        this.checkBehandlungsdatumError();
                        this.checkRechnungsdatumError();
                        this.checkGeburtsdatumError();
                        this.checkGeburtsdatumPatError();
                    }
                );
            }
            else {
                this.isEditing = false;
                this.auftrag.GewaehlterStandort = this.oroservice?.kundeninfo?.GewaehlterStandort;
                this.auftrag.NurVorrechtlichesInkasso = this.oroservice?.kundeninfo?.NurVorrechtInkasso;
                this.auftrag.Land = 0;
                this.auftrag.Forderungsgrund = this.oroservice?.kundeninfo?.Forderungsgrund;
                this.auftrag.Forderungsart = this.auftrag.Forderungsgrund === 11 ? 2 : 0; // Verlustschein
                this.auftrag.Anrede = null;
                this.auftrag.Briefanrede = this.briefanredeDe;
                this.auftrag.Titel = 0;
                this.auftrag.TitelSonstige = null;
                this.auftrag.Vorname = null;
                this.auftrag.Name = null;
                this.auftrag.Anschrift1 = null;
                this.auftrag.Anschrift2 = null;
                this.auftrag.Ort = null;
                this.auftrag.Plz = null;
                this.auftrag.Hausnummer = null;
                this.auftrag.Postfach = null;
                this.auftrag.Geburtsdatum = null;
                this.auftrag.AnredePatient = 0;
                this.auftrag.VornamePat = null;
                this.auftrag.NamePat = null;
                this.auftrag.Anschrift1Pat = null;
                this.auftrag.Anschrift2Pat = null;
                this.auftrag.OrtPat = null;
                this.auftrag.PlzPat = null;
                this.auftrag.LandPat = 0;
                this.auftrag.HausnummerPat = null;
                this.auftrag.PostfachPat = null;
                this.auftrag.GeburtsdatumPat = null;
                this.auftrag.IstPatient = true;
                this.auftrag.BeziehungPatient = 0;
                this.auftrag.Rechnungsdatum = null;
                this.auftrag.Betrag = null;
                this.auftrag.Teilzahlung = null;
                this.auftrag.Mahnkosten = null;
                this.auftrag.Kundenkosten = null;
                this.auftrag.Referenz = null;
                this.auftrag.GewaehlterStandort = -1;
                this.auftrag.Datum = null;
                this.auftrag.Behandlungsdatum = null;
                this.auftrag.Behandler = null;

                this.OldData = JSON.stringify(this.auftrag).replace(/null/g,"\"\"");
                this.hasBehandlungsdatumError = false;
                this.hasRechnungsdatumError = false;
                this.hasGeburtsdatumError = false;
                this.hasGeburtsdatumPatError = false;
                this.hasBehandlungsdatumInvalidError = false;
                this.hasBehandlungsdatumFutureError = false;
                this.hasRechnungsdatumBehandlungsdatumError = false;
                this.hasRechnungsdatumInvalidError = false;
                this.hasGeburtsdatumInvalidError = false;
                this.hasGeburtsdatumPatInvalidError = false;
                this.behandlungsdatumText = '';
                this.rechnungsdatumText = '';
                this.geburtsdatumText = '';
                this.geburtsdatumPatText = '';

                this.checkBehandlungsdatumError();
                this.checkRechnungsdatumError();
                this.checkGeburtsdatumError();
                this.checkGeburtsdatumPatError();
            }
        });
    }

    changeForderungsArt() {
        if (this.auftrag.Forderungsart === 2) {
            this.auftrag.Forderungsgrund = 11;
        }
        if (this.auftrag.Forderungsart !== 2 && this.auftrag.Forderungsgrund === 11) {
            this.auftrag.Forderungsgrund = this.oroservice?.kundeninfo?.Forderungsgrund ?? 0;
        }

        this.checkMindestbetragError();
    }

    compareBehandler(c1: any, c2: any): boolean {
        return c1 && c2 ? c1.Id === c2.Id : c1 === c2;
    }

    calcAge(dateString) {
        const birthday = +new Date(dateString);
        return ~~((Date.now() - birthday) / (31557600000));
    }

    isMinderjaehrig() {
        if (this.auftrag.Geburtsdatum) {
          const alter = this.calcAge(this.auftrag.Geburtsdatum);
            return (alter < 18);
        }
        else {
            return false;
        }
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }

    /**
      * Felder leeren für neue Auftrag.
      *
      * @param samePatient True wenn die Schuldner / Patient sind die gleiche wie im letzten Auftrag
      */
    private cleanFields(samePatient: boolean): void {
        // Allgemeine Felder
        this.auftrag.Id = 0;
        this.auftrag.Forderungsart = null;
        this.auftrag.Behandler = null;
        this.auftrag.Betrag = null;
        this.auftrag.Teilzahlung = null;
        this.auftrag.Rechnungsdatum = null;
        this.auftrag.Referenz = null;
        this.auftrag.Behandlungsdatum = null;
        this.auftrag.Forderungsgrund = this.oroservice?.kundeninfo?.Forderungsgrund;
        this.auftrag.NurVorrechtlichesInkasso = this.oroservice?.kundeninfo?.NurVorrechtInkasso;

        // Für die Validators (required)
        this.ctrForderungsart.markAsUntouched();
        this.ctrBetrag.markAsUntouched();
        this.ctrRechnungsdatum.markAsUntouched();
        this.ctrReferenz.markAsUntouched();

        if (!samePatient) {
            // Schuldner
            this.auftrag.Personenart = null;
            this.auftrag.Anrede = null;
            this.auftrag.Titel = null;
            this.auftrag.TitelSonstige = null;
            this.auftrag.Vorname = null;
            this.auftrag.Name = null;
            this.auftrag.Anschrift1 = null;
            this.auftrag.Anschrift2 = null;
            this.auftrag.Hausnummer = null;
            this.auftrag.Postfach = null;
            this.auftrag.Land = 0;
            this.auftrag.Plz = null;
            this.auftrag.Ort = null;
            this.auftrag.Geburtsdatum = null;
            this.auftrag.Briefanrede = this.briefanredeDe;

            // Patient
            this.auftrag.AnredePatient = null;
            this.auftrag.VornamePat = null;
            this.auftrag.NamePat = null;
            this.auftrag.GeburtsdatumPat = null;
            this.auftrag.BeziehungPatient = null;
            this.auftrag.LandPat = 0;

            this.ctrAnrede.markAsUntouched();
            this.ctrVorname.markAsUntouched();
            this.ctrName.markAsUntouched();
            this.ctrAnschrift.markAsUntouched();
            this.ctrHausnummer.markAsUntouched();
            this.ctrLand.markAsUntouched();
            this.ctrPLZ.markAsUntouched();
            this.ctrOrt.markAsUntouched();
            this.ctrAnredePat.markAsUntouched();
            this.ctrVornamePat.markAsUntouched();
            this.ctrNamePat.markAsUntouched();
            this.ctrBeziehungPat.markAsUntouched();
            this.ctrPersonenart.markAsUntouched();
            this.ctrBriefanrede.markAsUntouched();
            this.ctrAnschriftPat.markAsUntouched();
            this.ctrHausnummerPat.markAsUntouched();
            this.ctrLandPat.markAsUntouched();
            this.ctrPLZPat.markAsUntouched();
            this.ctrOrtPat.markAsUntouched();
        }
    }

    create(nextmode = false) {
        if (this.oroservice?.kundeninfo?.IsGesperrt) {
            this.oroservice.openDialogMessage('Neuauftrag.ErrorKundeninfoGesperrt');
            return;
        }

        const formdata = this.fileservice.getfiles();

        const json = JSON.stringify(this.auftrag).replace(/null/g,"\"\"");
        formdata.append("auftrag", json);
        this.oroservice.setAuftrag(formdata, false).then((object) => {
            if (object !==null && object.status===400) {
                this.openDialog("500px", "Meldung", object.error.Caption, "OK", "", DialogType.Info).subscribe();
            } else {
                this.fileservice.files = [];
                if (this.isEditing) {
                    this.oroservice.openDialogMessage("Neuauftrag.FeedbackSave");
                } else {
                    this.oroservice.openDialogMessage("Neuauftrag.FeedbackCreate");
                    this.cleanFields(nextmode);
                }

                this.convertDates();
                this.OldData = JSON.stringify(this.auftrag).replace(/null/g, "\"\"");
            }
        });
    }

    cancel() {
        this._location.back();
    }

    getFachrichtung(id: number) {
        return this.oroservice.kundeninfo.Fachrichtungen.filter(o => o.Id===id)[0]?.Name;
    }

    getCustomerNumberLabelKey(): string {
        const berufsgruppe = this.oroservice?.kundeninfo?.Berufsgruppe;
        if (!berufsgruppe) {
            return 'Rückfragen.Kundennummer';
        }

        const healthGroups = [1, 2, 3, 4, 5, 6, 9, 10, 12, 14, 15, 16, 17, 18, 21, 23, 24, 25, 26, 27, 28];
        return healthGroups.includes(berufsgruppe) ? 'Rückfragen.Patientennummer' : 'Rückfragen.Kundennummer';
    }

    toggleRemoveDokument() {
        this.auftrag.RemoveDokument = !this.auftrag.RemoveDokument;
    }

    private validateDateField(rawValue: any): Date | null {
        const value = rawValue ?? null;
        if (value === null || value === undefined || value === '') {
            return null;
        }

        return this.parseStrictDate(value);
    }

    private toInputDisplayValue(rawValue: any): string {
        if (rawValue === null || rawValue === undefined || rawValue === '') {
            return '';
        }

        return rawValue instanceof Date ? this.toDisplayDate(rawValue) : String(rawValue);
    }

    public checkBehandlungsdatumError(rawValue?: any) {
        if (rawValue !== undefined) {
            this.behandlungsdatumText = this.toInputDisplayValue(rawValue);
        }
        const inputValue = rawValue !== undefined ? rawValue : this.behandlungsdatumText;

        this.hasBehandlungsdatumError = false;
        this.hasBehandlungsdatumInvalidError = false;
        this.hasBehandlungsdatumFutureError = false;
        this.hasRechnungsdatumBehandlungsdatumError = false;

        if (inputValue === null || inputValue === undefined || inputValue === '') {
            return;
        }

        const behandlungsdatum = this.validateDateField(inputValue);
        if (!behandlungsdatum) {
            this.hasBehandlungsdatumInvalidError = true;
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        behandlungsdatum.setHours(0, 0, 0, 0);

        this.hasBehandlungsdatumFutureError = behandlungsdatum > today;

        const rechnungsdatum = this.validateDateField(this.auftrag.Rechnungsdatum);
        if (rechnungsdatum) {
            rechnungsdatum.setHours(0, 0, 0, 0);
            const hasRelationError = rechnungsdatum < behandlungsdatum;
            this.hasBehandlungsdatumError = hasRelationError;
            this.hasRechnungsdatumBehandlungsdatumError = hasRelationError;
        }
    }

    public checkTeilzahlungsError() {
        this.hasTeilzahlungsError = parseFloat(this.auftrag.Betrag) <= parseFloat(this.auftrag.Teilzahlung);
        this.checkMindestbetragError();
    }

    public checkMindestbetragError() {
        const betrag = parseFloat(this.auftrag.Betrag) || 0;
        const teilzahlung = parseFloat(this.auftrag.Teilzahlung) || 0;
        const effectiveAmount = this.auftrag.Forderungsart===2 ? betrag - teilzahlung : betrag;

        this.hasMindestbetragError = effectiveAmount < 10;
    }

    public checkRechnungsdatumError(rawValue?: any) {
        if (rawValue !== undefined) {
            this.rechnungsdatumText = this.toInputDisplayValue(rawValue);
        }
        const inputValue = rawValue !== undefined ? rawValue : this.rechnungsdatumText;

        this.hasRechnungsdatumError = false;
        this.hasRechnungsdatumInvalidError = false;
        this.hasRechnungsdatumBehandlungsdatumError = false;

        if (inputValue === null || inputValue === undefined || inputValue === '') {
            return;
        }

        const rechnungsdatum = this.validateDateField(inputValue);
        if (!rechnungsdatum) {
            this.hasRechnungsdatumInvalidError = true;
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        rechnungsdatum.setHours(0, 0, 0, 0);

        this.hasRechnungsdatumError = rechnungsdatum > today;
        const behandlungsdatum = this.validateDateField(this.auftrag.Behandlungsdatum);
        if (behandlungsdatum) {
            behandlungsdatum.setHours(0, 0, 0, 0);
        }
        this.hasRechnungsdatumBehandlungsdatumError = behandlungsdatum !==null && rechnungsdatum < behandlungsdatum;
    }

    public checkGeburtsdatumError(rawValue?: any) {
        if (rawValue !== undefined) {
            this.geburtsdatumText = this.toInputDisplayValue(rawValue);
        }
        const inputValue = rawValue !== undefined ? rawValue : this.geburtsdatumText;
        this.hasGeburtsdatumInvalidError = false;
        this.hasGeburtsdatumError = false;

        if (inputValue === null || inputValue === undefined || inputValue === '') {
            return;
        }

        const geb = this.validateDateField(inputValue);
        if (!geb) {
            this.hasGeburtsdatumInvalidError = true;
            return;
        }

        const today = new Date();
        geb.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        this.hasGeburtsdatumError = geb > today;
    }

    public checkGeburtsdatumPatError(rawValue?: any) {
        if (rawValue !== undefined) {
            this.geburtsdatumPatText = this.toInputDisplayValue(rawValue);
        }
        const inputValue = rawValue !== undefined ? rawValue : this.geburtsdatumPatText;
        this.hasGeburtsdatumPatInvalidError = false;
        this.hasGeburtsdatumPatError = false;

        if (inputValue === null || inputValue === undefined || inputValue === '') {
            return;
        }

        const geb = this.validateDateField(inputValue);
        if (!geb) {
            this.hasGeburtsdatumPatInvalidError = true;
            return;
        }

        const today = new Date();
        geb.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        this.hasGeburtsdatumPatError = geb > today;
    }

    public canSubmit() : boolean {
        if (this.oroservice?.kundeninfo?.IsGesperrt) {
            return false;
        }

        this.checkBehandlungsdatumError();
        this.checkRechnungsdatumError();
        this.checkGeburtsdatumError();
        this.checkGeburtsdatumPatError();
        this.checkMindestbetragError();

        if (this.hasBehandlungsdatumInvalidError || this.hasBehandlungsdatumFutureError || this.hasRechnungsdatumInvalidError || this.hasRechnungsdatumBehandlungsdatumError || this.hasGeburtsdatumInvalidError || this.hasGeburtsdatumPatInvalidError || this.hasMindestbetragError) {
            return false;
        }

        if (!this.auftrag.Forderungsart) {
            return false;
        }

        if (!this.auftrag.Betrag || this.auftrag.Betrag <= 0) {
            return false;
        }

        if (!this.auftrag.Rechnungsdatum) {
            return false;
        }

        if (!this.auftrag.Referenz) {
            return false;
        }

        if (!this.auftrag.Name) {
            return false;
        }

        if (!this.auftrag.Personenart) {
            return false;
        }

        if (!this.auftrag.Forderungsgrund) {
            return false;
        }

        if (this.oroservice?.kundeninfo?.Standorte?.length > 1 && this.auftrag.GewaehlterStandort <= 0) {
            return false;
        }

        // Natürliche Person
        if (this.auftrag.Personenart===1) {
            if (!this.auftrag.Vorname) {
                return false;
            }

            if (!this.auftrag.Anrede) {
                return false;
            }
        }

        // Juridische Person
        if (this.auftrag.Personenart===2) {
            if (!this.auftrag.Rechtsform) {
                return false;
            }
        }

        if (!this.auftrag.Anschrift1 && !this.auftrag.Postfach) {
            return false;
        }

        if (!this.auftrag.Hausnummer) {
            return false;
        }

        if (!this.auftrag.Plz) {
            return false;
        }

        if (!this.auftrag.IstPatient) {
            if (!this.auftrag.VornamePat) {
                return false;
            }

            if (!this.auftrag.NamePat) {
                return false;
            }

            if (!this.auftrag.AnredePatient) {
                return false;
            }

            if (!this.auftrag.BeziehungPatient) {
                return false;
            }
        }

        return !(this.fileservice.isFileTooBig || this.hasBehandlungsdatumError || this.hasRechnungsdatumError || this.hasTeilzahlungsError || this.hasGeburtsdatumError || this.hasGeburtsdatumPatError || this.hasMindestbetragError);
    }

    checkPlz(plz?: string) {
        const currentPlz = plz ?? this.auftrag.Plz;

        if (this.auftrag.Land===0) {
            if (currentPlz && currentPlz.length===4) {
                this.oroservice.getOrtList(currentPlz).then(res => {
                    this.plzinfolisteFilter = res;
                    if (this.plzinfolisteFilter.length > 0) {
                        this.auftrag.Ort = this.plzinfolisteFilter[0].Ort;
                    } else {
                        this.auftrag.Ort = "";
                    }
                }).catch((error) => {
                    //return this.handleerror(error);
                });
            } else {
                if (currentPlz && currentPlz.length < 4) {
                    this.auftrag.Ort = "";
                    this.plzinfolisteFilter = [];
                } else if (currentPlz) {
                    this.auftrag.Plz = currentPlz.substring(0, 4);
                } else {
                    this.auftrag.Ort = "";
                    this.plzinfolisteFilter = [];
                }
            }
        }
    }

    checkPlzPat(plz?: string) {
        const currentPlz = plz ?? this.auftrag.PlzPat;

        if (this.auftrag.LandPat===0) {
            if (currentPlz && currentPlz.length===4) {
                this.oroservice.getOrtList(currentPlz).then(res => {
                    this.plzinfolisteFilterPat = res;
                    if (this.plzinfolisteFilterPat.length > 0) {
                        this.auftrag.OrtPat = this.plzinfolisteFilterPat[0].Ort;
                    } else {
                        this.auftrag.OrtPat = "";
                    }
                }).catch((error) => {
                    //return this.handleerror(error);
                });
            } else {
                if (currentPlz && currentPlz.length < 4) {
                    this.auftrag.OrtPat = "";
                    this.plzinfolisteFilterPat = [];
                } else if (currentPlz) {
                    this.auftrag.PlzPat = currentPlz.substring(0, 4);
                } else {
                    this.auftrag.OrtPat = "";
                    this.plzinfolisteFilterPat = [];
                }
            }
        }
    }
}
